import { styled } from '@mui/material';

export const StrategySelectionStyled = styled('div')`
  .MuiDivider-root {
    margin: 1rem 0rem;
  }
`;
